module.exports = __webpack_public_path__ + "static/media/foto_bu_nur.aadeccb3.png";